export const getPriorityColor = (type) => {
  if (!type) return "#8b5cf6";

  const typeLower = type.toLowerCase();
  if (
    typeLower.includes("breached") ||
    typeLower.includes("late") ||
    typeLower.includes("flag")
  ) {
    return "#ef4444";
  }
  if (typeLower.includes("unallocated") || typeLower.includes("removed")) {
    return "#f59e0b";
  }
  if (typeLower.includes("allocated")) {
    return "#22c55e";
  }
  return "#3b82f6";
};